<template>
  <table class=" table table-sm table-hover ">
    <caption class="table-caption text-left" v-if="isPortfolio == true && isMatrixClicked == true">
      {{dealName}}, Bond {{bondName}} Cash Flow{{', Scenario Name: ' + scenarioName}}
      <b-form-checkbox v-if="miscVariables" v-model="showDebugInfo" class="transformed">Show Trigger Info</b-form-checkbox>
    </caption>
    <caption class="table-caption text-left" v-else-if="isPortfolio == true">
      Bond Portfolio Cash Flow{{', Scenario Name: ' + scenarioName}}
      <b-form-checkbox v-if="miscVariables" v-model="showDebugInfo" class="transformed">Show Trigger Info</b-form-checkbox>
    </caption>
    <caption class="table-caption text-left" v-else>
      {{getDealName()}}, Bond {{bond.BondName}} Cash Flow{{ isMatrixClicked ? ', CPR; ' + cpr + '%, CDR; ' + cdr + '%' : '' }}
      <b-form-checkbox v-if="miscVariables" v-model="showDebugInfo" class="transformed">Show Trigger Info</b-form-checkbox>
    </caption>
    <thead>
    <tr>
      <th class="sticky">Period</th>
      <th class="text-right text-nowrap sticky">Payment Date</th>
      <th class="text-right sticky">Balance</th>
      <th class="text-right sticky">Interest</th>
      <th class="text-right sticky">Principal</th>
      <th class="text-right sticky">Rate</th>
      <th class="text-right sticky">Cash</th>
      <th class="text-right sticky">Writedown</th>
      <th class="text-right sticky">CPR Rate</th>
      <th class="text-right sticky">CDR Rate</th>
      <th class="text-right sticky">Loss Severity Rate</th>
      <th class="text-right sticky">Delinquency Rate</th>
      <template v-if="compDebugData">
        <template v-for="h of compDebugData.headers">
          <th class="text-right sticky debug">{{h}}</th>
        </template>
      </template>
    </tr>
    </thead>
    <tbody>
      <template v-for="row in bonds">
        <tr :key=row.Period>
          <td>{{row.Period}}</td>
          <td class="text-right">{{row.PaymentDate}}</td>
          <td class="text-right">{{row.Balance}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.Interest)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.Principal)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.Rate)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.Cash)}}</td>
          <td class="text-right">{{row.ActualWriteDown}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.CprRate)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.CdrRate)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.LossSeverityRate)}}</td>
          <td class="text-right">{{skipFirstRow(row.Period, row.DelinquencyRate)}}</td>
          <template v-if="compDebugData">
            <template v-for="cell of compDebugData.rows[row.Period]">
              <td class="debug">{{cell}}</td>
            </template>
          </template>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import UtilsTableDataBuilder from "@/utilities/UtilsTableDataBuilder";

export default {
  props: ['bond', 'isMatrixClicked', 'cpr', 'cdr', 'isPortfolio', 'dealName', 'bondName', 'scenarioName', 'miscVariables'],
  computed: {
    bonds() {
      if (this.isPortfolio) { return this.bond }
      return this.bond.BondCashflow
    },
    compDebugData: function() {
      let res = null;
      if (this.showDebugInfo && this.miscVariables.length > 0) {
        const columnFormatters = [
          {DbName: "Pd", DataType: "String. Aligned left"},
          {DbName: "Period", DataType: "String. Aligned left"},
        ];
        res = new UtilsTableDataBuilder(this.miscVariables, columnFormatters);
      }
      return res;
    }
  },
  data() {
    return {
      showDebugInfo: false
    }
  },
  methods: {
    getDealName() {
      return this.$store.getters.dealName;
    },
    skipFirstRow(index, value) {
      return index != 0 ? value : ''
    },
    toMatrix() {
      let cashflow = [ ['Period', 'Payment Date', 'Balance', 'Interest', 'Principal', 'Rate', 'Cash',
        'Writedown', 'CPR Rate', 'CDR Rate', 'Loss Severity Rate', 'Delinquency Rate'] ]

      for (let row of this.bonds) {
        cashflow.push(
          [
            row.Period,
            row.PaymentDate,
            row.Balance,
            this.skipFirstRow(row.Period, row.Interest),
            this.skipFirstRow(row.Period, row.Principal),
            this.skipFirstRow(row.Period, row.Rate),
            this.skipFirstRow(row.Period, row.Cash),
            row.ActualWriteDown,
            this.skipFirstRow(row.Period, row.CprRate),
            this.skipFirstRow(row.Period, row.CdrRate),
            this.skipFirstRow(row.Period, row.LossSeverityRate),
            this.skipFirstRow(row.Period, row.DelinquencyRate)
          ])
      }
      let result = cashflow

      return result
    }
  }
}
</script>
